import Header from './components/Header';
import Hero from './components/Hero';
import TrustStrip from './components/TrustStrip';
import Difference from './components/Difference';
import HowItWorks from './components/HowItWorks';
import Services from './components/Services';
import PostConstruction from './components/PostConstruction';
import LuxuryVilla from './components/LuxuryVilla';
import WhyViaypii from './components/WhyViaypii';
import Locations from './components/Locations';
import Conversion from './components/Conversion';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import MobileBar from './components/MobileBar';

export default function Home() {
  return (
    <div className="min-h-screen bg-warm-white">
      <Header />
      <main>
        <Hero />
        <TrustStrip />
        <Difference />
        <HowItWorks />
        <Services />
        <PostConstruction />
        <LuxuryVilla />
        <WhyViaypii />
        <Locations />
        <Conversion />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <div className="h-20 md:hidden"></div>
      <MobileBar />
    </div>
  );
}